<template>
    <div>

        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader class="p-1">
                        <CRow>
                            <CCol col="8" style="text-align: start ;padding:10px 20px 0 20px ">
                                <strong>{{$t('sidebars.payroll')}}</strong>

                            </CCol>
                            <CCol col="4" style="text-align: end">
                                <CButton
                                        v-if="$route.params.id==null"
                                        class="mr-1 ml-1"
                                        size="sm"
                                        color="secondary"
                                        @click="add_salary()"
                                >{{ $t("buttons.submit") }}
                                </CButton>
                                <CButton
                                        v-else
                                        class="mr-1 ml-1"
                                        size="sm"
                                        color="secondary"
                                        @click="add_salary()"
                                >{{ $t("buttons.edit") }}
                                </CButton>
                                <CButton
                                        class="mr-1"
                                        size="sm"
                                        color="secondary"
                                >{{ $t("buttons.print") }}
                                </CButton>

                            </CCol>
                        </CRow>
                        <!--        </div>-->

                        <!-- Right aligned nav items -->
                        <!--      </CCollapse>-->
                    </CCardHeader>

                    <CCardBody>
                        <CRow>
                            <CCol col="5">
                                <CRow>
                                    <CCol col="6">
                                        <date-picker

                                                :label="$t('components.startDate')"
                                                v-model="start_date"
                                                :min="get_min_doc_date()"
                                                :max="get_max_doc_date()"
                                        ></date-picker>
                                    </CCol>
                                    <CCol col="6">
                                        <date-picker
                                                :label="$t('components.endDate')"
                                                v-model="end_date"
                                                :min="get_min_doc_date()"
                                                :max="get_max_doc_date()"></date-picker>

                                    </CCol>

                                </CRow>
                            </CCol>
                            <CCol col="1">
                                <label class="col-form-label">{{$t('week')}} : {{ start_date_week }}</label>
                            </CCol>
                            <CCol col="1">
                                <label class="col-form-label">{{$t('month')}}: {{ start_date_month }}</label>
                            </CCol>
                            <CCol col="2">
                                <CInput
                                        v-model="search_data"
                                        :placeholder="$t('search')"
                                />
                            </CCol>
                            <CCol col="2">
                                <label style="float: right" class="col-form-label">{{$t('totalSum')}} : {{
                                    get_currency(get_all_total_price())}}</label>

                            </CCol>
                        </CRow>
                        <CDataTable
                                :items="filtered_items_customer"
                                :fields="fields"
                                :items-per-page="8"
                                hover

                                :responsive="false"
                                add-table-classes="width-2000 overfly-x-auto"
                                style="overflow-x: scroll"
                                sorter
                                pagination
                        >
                            <template #row_id="{item}">

                                <td style="text-align: center">

                                    <p>{{ item.row_id + 1 }}</p>

                                </td>

                            </template>
                            <template #userName="{item}">

                                <td>
                                    <p>{{ item.userName }}</p>

                                </td>

                            </template>
                            <template #surName="{item}">
                                <td>
                                    <p>{{ item.surName }}</p>
                                </td>
                            </template>
                            <template #personCode="{item}">
                                <td>
                                    <p v-if="item.personCode!=null">{{ item.personCode }}</p>
                                </td>
                            </template>
                            <template #phone="{item}">
                                <td>
                                    <p>{{ item.mobileNo }}</p>

                                </td>

                            </template>

                            <template #costCenter="{item}">
                                <td>
                                    <CSelect class="p-0 m-0" :options="get_cost_centes(item)"
                                             :value.sync="item.costCenter"
                                    />
                                </td>

                            </template>
                            <template #hours="{item,index}">
                                <td>
                                    <CInput class="p-0 m-0" v-model="item.hours"
                                            @keyup.enter="another_focus(index+'extraHours')" :id="index+'hours'"/>
                                </td>
                            </template>

                            <template #extraHours="{item,index}">
                                <td>
                                    <CInput class="p-0 m-0" v-model="item.extraHours"
                                            @keyup.enter="another_focus(index+'holidayHours')"
                                            :id="index+'extraHours'"/>
                                </td>
                            </template>
                            <template #holidayHours="{item,index}">
                                <td>
                                    <CInput class="p-0 m-0" v-model="item.holidayHours"
                                            @keyup.enter="another_focus(index+'nightHours')"
                                            :id="index+'holidayHours'"/>
                                </td>
                            </template>
                            <template #nightHours="{item,index}">
                                <td>
                                    <CInput class="p-0 m-0" v-model="item.nightHours"
                                            @keyup.enter="another_focus(index+'penaltyHours')"
                                            :id="index+'nightHours'"/>
                                </td>
                            </template>

                            <template #penaltyHours="{item,index}">
                                <td>
                                    <CInput class="p-0 m-0" v-model="item.penaltyHours"
                                            @keyup.enter="another_focus(index+'reward')" :id="index+'penaltyHours'"/>
                                </td>
                            </template>
                            <template #reward="{item,index}">
                                <td>
                                    <CInputCurrency class="p-0 m-0" v-model="item.reward"
                                                    @keyup.enter="another_focus(index+'received')"
                                                    :id="index+'reward'"/>

                                </td>
                            </template>
                            <template #received="{item,index}">
                                <td>
                                    <CInputCurrency class="p-0 m-0" v-model="item.received" :id="index+'received'"/>

                                </td>
                            </template>
                            <template #wage="{item}">
                                <td>
                                    <label class="p-0 mr-2 ml-2">{{get_currency(item.wage)}}</label>
                                    <CButton
                                            :href="'/dashboard/users/edit-user/'+item.userId" target="_blank"
                                            color="dark"
                                            size="sm">
                                        <CIcon size="sm" name="cil-user"/>
                                    </CButton>
                                </td>
                            </template>

                            <template #note="{item}">
                                <td>
                                    <CInput class="p-0 m-0" v-model="item.note"/>
                                </td>
                            </template>

                            <template #SumHours="{item}">
                                <td>
                                    <p v-if="get_sum_hours(item)>0">{{ get_sum_hours(item) }}</p>
                                    <p v-if="get_sum_hours(item)<0" class="text-danger">{{ get_sum_hours(item) * -1
                                        }}</p>
                                </td>
                            </template>


                            <template #price="{item}">
                                <td>
                                    <p v-if="get_sum_wage(item)>0" style="float: right">{{
                                        get_currency(get_sum_wage(item)) }}</p>
                                    <p v-if="get_sum_wage(item)<0" class="text-danger" style="float: right">{{
                                        get_currency(get_sum_wage(item) * -1) }}</p>
                                </td>
                            </template>

                            <template #totalPrice="{item}">
                                <td>
                                    <p v-if="get_total_wage(item)>0" style="float: right">{{
                                        get_currency(get_total_wage(item)) }}</p>
                                    <p v-if="get_total_wage(item)<0" class="text-danger" style="float: right">{{
                                        get_currency(get_total_wage(item) * -1) }}</p>
                                </td>
                            </template>


                            <template #under-table>
                                <CRow class="width-2000">

                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>
                                    <CCol></CCol>


                                    <CCol>{{ $t('totalCirculation') }}</CCol>
                                    <CCol>{{ get_currency(calculate_items(filtered_items_customer,'price')) }}</CCol>
                                    <CCol>{{ get_currency(calculate_items(filtered_items_customer,'received')) }}</CCol>
                                    <CCol>{{ get_currency(calculate_items(filtered_items_customer,'totalPrice')) }}
                                    </CCol>
                                    <CCol></CCol>

                                </CRow>


                            </template>
                        </CDataTable>


                    </CCardBody>

                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    import Vue from 'vue'

    var items_data = [];
    import CInputNumber from "../includes/CInputNumber";
    import moment from 'moment-jalaali'

    export default {
        name: 'Login',
        components: {
            CInputNumber
        },
        data() {
            return {
                confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
                name: '',
                file: '',
                color: '#ffffff',
                night_ration: 2,
                extra_ration: 2,
                holiday_ration: 2,
                search_data: '',
                previewImage: '',
                selected_template: 0,
                description: '',
                saleMethodModal: false,
                method_list: [],
                selected_method: '',
                selected_person: 0,
                start_date_week: '',
                start_date_month: '',
                start_date: '',
                end_date: '',
                items_customer: [],
                filtered_items_customer: [],
                fields: [
                    {key: 'row_id', label: this.$t('tables.row'), sorter: false, _style: 'width:30px'},
                    {key: 'personCode', label: this.$t('personalNo'), _style: 'width:50px'},
                    {key: 'userName', label: this.$t('name'), _style: 'width:50px'},
                    {key: 'surName', label: this.$t('lastName'), _style: 'width:70px'},
                    {key: 'hours', label: this.$t('totalWork'), _style: 'width:50px'},
                    {key: 'extraHours', label: this.$t('extraJob'), _style: 'width:50px'},
                    {key: 'holidayHours', label: this.$t('holidayJob'), _style: 'width:50px'},
                    {key: 'nightHours', label: this.$t('nightJob'), _style: 'width:50px'},

                    {key: 'penaltyHours', label: this.$t('minusWork'), _style: 'width:50px'},
                    {key: 'SumHours', label: this.$t('sumWork'), _style: 'width:50px'},

                    {key: 'reward', label: this.$t('Reward') + " " + this.currency_symbol(), _style: 'width:50px'},
                    {key: 'price', label: this.$t('tables.amount'), _style: 'width:50px'},
                    {key: 'received', label: this.$t('receivedPrice'), _style: 'width:50px'},
                    {key: 'totalPrice', label: this.$t('payablePrice'), _style: 'width:50px'},
                    {key: 'costCenter', label: this.$t('costCenter'), _style: 'width:80px'},
                    {key: 'wage', label: this.$t('wage'), _style: 'width:100px'},
                    {key: 'note', label: this.$t('components.documentSummary'), _style: 'width:120px'},

                    // {key: 'isCustomer', label: this.$t('tables.isCustomer'), _style: 'width:10%'},
                    // {key: 'isVendor', label: this.$t('tables.isVendor'), _style: 'width:10%'},
                    // {key: 'isWorker', label: this.$t('tables.isWorker'), _style: 'width:10%'},
                    // {key: 'permission', label: this.$t('tables.role'), _style: 'width:5%'},
                    // {key: 'saleMethodName', label: this.$t('tables.saleMethod'), _style: 'width:10%'},

                    // {key: 'operation', label: this.$t('tables.operation'), _style: 'width:20%;'},

                ],
                items_worker: [],
                // fields,

                items_vendor: [],
                // fields,

                details: [],
                templates_items: [
                    {template_id: 'One', name: 'A'},
                    {template_id: 'Two', name: 'B'},
                    {template_id: 'Three', name: 'C'}
                ],
                collapseDuration: 0,
                status_form: 0
            }
        },
        computed1: {},
        mounted() {
            this.get_lists();
            this.$root.root_validate_errors = [];
            this.get_method_lists();

            bus.$on(this.confirm_delete_name, (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            'start_date': function () {
                var start = moment(this.start_date, 'YYYY-MM-DD');
                var start2 = moment(this.start_date, 'YYYY-MM-DD');
                this.end_date = start2.add(6, 'day').format('YYYY-MM-DD');

                this.start_date_month = start.format('MMMM');
                if (this.$i18n.locale == "fa") {
                    start = start.locale('fa');
                    this.start_date_month = start.locale('fa').format('jMMMM');

                    this.start_date_week = start.locale('fa').format('jw');
                } else {
                    start = start.locale(this.$i18n.locale);
                    this.start_date_month = start.locale(this.$i18n.locale).format('MMMM');
                    // this.start_date_week = moment(this.start_date, 'YYYY-MM-DD').week();
                    console.log("first day of week", start.day());
                    this.start_date_week = start.locale(this.$i18n.locale).format('w');
                    // if(start.day()==6){
                    this.start_date_week = this.start_date_week - 1;
                    // }
                }
            },
            'search_data': function () {
                this.filtered_items_customer = this.items_customer.filter(x =>
                    x.personCode.toLowerCase().includes(this.search_data.toLowerCase()) || x.userName.toLowerCase().includes(this.search_data.toLowerCase()) || x.surName.toLowerCase().includes(this.search_data.toLowerCase()))
            }
        },
        methods: {
            get_all_total_price() {
                var total_price = 0;
                for (var i = 0; i < this.items_customer.length; i++) {
                    total_price = total_price + this.get_total_wage(this.items_customer[i])
                }
                return total_price
            },
            get_sum_hours(item) {
                console.log('sum hours called');
                var hours = 0;

                if (item.hours != null && item.hours != '') {
                    hours = hours + parseInt(item.hours);
                }
                if (item.extraHours != null && item.extraHours != '') {
                    hours = hours + parseInt(item.extraHours) + ((parseInt(item.extraHours) * this.extra_ration) / 100);
                }
                if (item.holidayHours != null && item.holidayHours != '') {
                    hours = hours + parseInt(item.holidayHours) + ((parseInt(item.holidayHours) * this.holiday_ration) / 100);
                }
                if (item.nightHours != null && item.nightHours != '') {
                    hours = hours + parseInt(item.nightHours) + ((parseInt(item.nightHours) * this.night_ration) / 100);
                }
                if (item.penaltyHours != null && item.penaltyHours != '') {
                    hours = hours - parseInt(item.penaltyHours);
                }

                return parseFloat(hours).toFixed(2);
            },
            get_sum_wage(item) {
                var wage = 0;
                var hours = this.get_sum_hours(item);
                if (item.wage != null && item.wage != '') {
                    wage = hours * (item.wage).toString().replace(/,/g, '');
                }
                if (item.reward != null && item.reward != '') {
                    wage = wage + parseFloat((item.reward).toString().replace(/,/g, ''));
                }
                item.price = wage;
                return wage;
            },
            get_total_wage(item) {
                var total_wage = 0
                if (item.received == null || item.received == '') {
                    total_wage = this.get_sum_wage(item);
                } else {
                    total_wage = this.get_sum_wage(item) - parseFloat((item.received).toString().replace(/,/g, ''));
                }
                item.totalPrice = total_wage
                return total_wage;
            },
            get_cost_centes(item) {
                var centes = []
                for (var i = 0; i < item.costCenters.length; i++) {
                    centes.push({label: item.costCenters[i].title, value: item.costCenters[i].id})
                }
                return centes
            },

            get_method_lists() {
                var self = this;

                const formData = new FormData();


                axios.post('GetBusinessPublic', formData, {}).then(function (response) {

                    var content_data = response.data;

                    if (content_data.statusCode == 0) {
                        self.night_ration = content_data.data.nightJob
                        self.extra_ration = content_data.data.upperJob
                        self.holiday_ration = content_data.data.hollidayJob

                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_lists() {
                if (this.$route.params.id != null) {
                    this.get_salary_info();
                    return
                }
                var self = this;


                const formData = new FormData();

                var url = "GetAllPersons";

                formData.append('IsVendor', false);
                formData.append('IsWorker', true);
                formData.append('IsCustomer', false);
                formData.append('IsActive', 0);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_customer = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });

                        for (var i = 0; i < self.items_customer.length; i++) {
                            // self.items_customer[i].penaltyHours = '0';


                            if (self.items_customer[i].personCode == null) {
                                self.items_customer[i].personCode = ''
                            }
                            if (self.items_customer[i].userName == null) {
                                self.items_customer[i].userName = ''
                            }
                            if (self.items_customer[i].surName == null) {
                                self.items_customer[i].surName = ''
                            }
                        }
                        self.filtered_items_customer = self.items_customer.filter(x => x.pStatusId == 39);


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            get_salary_info() {
                var self = this;


                const formData = new FormData();

                var url = "GetPayrollDocById";

                formData.append('FactorId', self.$route.params.id);

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items_customer = content_data.data.details.map((item, row_id) => {
                            return {...item, row_id}
                        });
                        self.factor = content_data.data
                        self.start_date = self.factor.fromDate.substring(0, 10);
                        self.end_date = self.factor.toDate.substring(0, 10);
                        for (var i = 0; i < self.items_customer.length; i++) {
                            // self.items_customer[i].penaltyHours = '0';
                            Vue.set(self.items_customer[i], 'extraHours', self.items_customer[i].overtime)
                            Vue.set(self.items_customer[i], 'holidayHours', self.items_customer[i].holiday)
                            Vue.set(self.items_customer[i], 'nightHours', self.items_customer[i].nightShift)
                            Vue.set(self.items_customer[i], 'hours', self.items_customer[i].totalWork)
                            Vue.set(self.items_customer[i], 'penaltyHours', self.items_customer[i].minusWork)
                            Vue.set(self.items_customer[i], 'received', self.items_customer[i].receivedAmount)
                            Vue.set(self.items_customer[i], 'userName', self.items_customer[i].personName)
                            // self.items_customer[i].extraHours = self.items_customer[i].overtime
                            // self.items_customer[i].holidayHours = self.items_customer[i].holiday
                            // self.items_customer[i].nightHours = self.items_customer[i].nightShift
                            // self.items_customer[i].hours = self.items_customer[i].totalWork
                            // self.items_customer[i].penaltyHours = self.items_customer[i].minusWork
                            // self.items_customer[i].received = self.items_customer[i].receivedAmount
                            // self.items_customer[i].userName = self.items_customer[i].personName
                            // self.items_customer[i].surName = self.items_customer[i].surName

                            if (self.items_customer[i].personCode == null) {
                                self.items_customer[i].personCode = ''
                            }
                            if (self.items_customer[i].userName == null) {
                                self.items_customer[i].userName = ''
                            }
                            if (self.items_customer[i].surName == null) {
                                self.items_customer[i].surName = ''
                            }

                            self.items_customer[i].userId = self.items_customer[i].personId

                        }
                        self.filtered_items_customer = self.items_customer;


                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },

            prepare_salary() {

            },
            add_salary() {
                var self = this;
                const formData = new FormData();

                var url = "AddPayrollDoc";
                var master_id = 0;
                if (this.start_date == null || this.start_date == "") {
                    this.$root.modal_component.show_validate_errors([this.$t('dialogs.insertDate')])

                    return false;
                }
                var master = {FromDate: this.start_date, ToDate: this.end_date, ItemDesc: ''};
                if (self.$route.params.id != null) {
                    url = "EditPayrollDoc ";
                    master_id = self.$route.params.id;
                    master.Id = self.$route.params.id;
                }
                var details = [];
                this.items_customer.forEach((val) => {
                    if (val.wage && val.hours) {
                        if (val.costCenter == null) {
                            val.costCenter = this.get_cost_centes(val)[0].value
                        }
                        if (val.received == null || val.received == "") {
                            val.received = 0
                        }
                        var obj = {
                            MasterId: master_id,
                            PersonId: val.userId,
                            TotalWork: val.hours,
                            Overtime: val.extraHours,
                            Holiday: val.holidayHours,
                            NightShift: val.nightHours,
                            MinusWork: val.penaltyHours,
                            SumWork: this.get_sum_hours(val),
                            Reward: val.reward,
                            Amount: this.get_sum_wage(val),
                            ReceivedAmount: (val.received).toString().replace(/,/g, ''),
                            PayableAmount: this.get_total_wage(val),
                            CostCenter: val.costCenter,
                            Wage: (val.wage).toString().replace(/,/g, ''),
                            Note: (val.note),
                        }
                        if (obj.Overtime == null || obj.Overtime == "") {
                            obj.Overtime = 0
                        }
                        if (obj.Holiday == null || obj.Holiday == "") {
                            obj.Holiday = 0
                        }
                        if (obj.NightShift == null || obj.NightShift == "") {
                            obj.NightShift = 0
                        }
                        if (obj.MinusWork == null || obj.MinusWork == "") {
                            obj.MinusWork = 0
                        }
                        if (obj.Reward == null || obj.Reward == "") {
                            obj.Reward = 0
                        }
                        if (obj.ReceivedAmount == null || obj.ReceivedAmount == "") {
                            obj.ReceivedAmount = 0
                        }
                        details.push(obj);
                    }
                });
                if (details.length == 0) {
                    this.$root.modal_component.show_validate_errors([this.$t('dialogs.selectUser')])

                    return false;
                }
                var model = {Master: JSON.stringify(master), Details: JSON.stringify(details)};


                // formData.append('Master', this.start_date);
                // formData.append('SecondDate', this.end_date);
                // formData.append('PersonId', item.userId);
                // formData.append('Sallary', item.Wage);
                // formData.append('JobHours', item.hours);
                // formData.append('CostCenterId', 0);
                formData.append('input', JSON.stringify(model));
                // formData.append('Master',JSON.stringify(master) );
                // formData.append('Details',JSON.stringify(details) );

                axios.post(url, formData, {}).then(function (response) {

                    var content_data = response.data;
                    self.$root.modal_component.show_api_response_modals(response);

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {

                        self.get_lists()
                        if (self.$route.params.id != null) {
                            self.$router.go(-1)
                        }

                        bus.$emit('sallary_update', "");
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },


        }
    }

</script>
<style>
    .width-2000 {
        width: 1500px !important;
    }
</style>
